// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal-title{padding:0 !important}.modal-title h2{padding:0 !important}h2{font-size:24px;font-weight:300;margin:0;padding:20px 0 12px;text-align:center;white-space:pre-wrap}.mat-mdc-checkbox{margin-top:8px;width:100%;justify-content:center;display:flex}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
